<template>
  <div class="box">
    <div class="login">
      <div class="login_bgd">
        <img src="../../assets/mobVisitor/login.png" alt="" />
      </div>
      <div class="login_title">
        <img src="../../assets/mobVisitor/title.png" alt="" />
        <div>欢迎使用雷士访客管理系统</div>
        <p>光 / 随 / 心 / 行 &emsp; 智 / 亮 / 未 / 来</p>
      </div>
      <div class="login_form">
        <div class="login_form_right">
          <el-input v-model="username" placeholder="请输入账号"></el-input>
          <el-input
            v-model="password"
            placeholder="请输密码"
            type="password"
          ></el-input>
          <el-button type="primary" @click="login">登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
export default {
  data() {
    return {
      username: "",
      password: "",
      // username: '18501633638',
      // password: '18501633638',
    };
  },
  mounted() {},
  methods: {
    login() {
      api
        .login({
          username: this.username,
          password: this.password,
        })
        .then((res) => {
          if (res.code == 200) {
            sessionStorage.setItem("mobusername", res.data.username);
            this.$router.replace({
              path: "/mobVisitor",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020/375;
@media screen and (max-width: 600px) {
  .login {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .login {
    width: 276px * $zoom;
  }
}
.box {
  font-size: 16px * $zoom;
  // width: 380px * $zoom;
  display: flex;
  justify-content: center;
  height: 100vh;
  // background: #f0f0f0;
  overflow: hidden;
}
.login {
  position: relative;
  // width: 100%;
  // overflow: hidden;
  .login_bgd {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login_title {
    position: absolute;
    left: 10%;
    top: 10%;
    img {
      width: 272px;
      height: 58px;
    }
    div {
      font-size: 38px;
      color: rgba(43, 43, 43, 1);
      margin-top: 6px;
      margin-bottom: 16px;
    }
    p {
      font-size: 28px;
      color: rgba(102, 102, 102, 1);
    }
  }
  .login_form {
    position: absolute;
    left: 50%;
    top: 63%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 74%;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
    border-radius: 50px 50px 0 0;
    padding-top: 40px;
    .login_form_right {
      width: 100%;
      ::v-deep .el-input {
        display: block;
        width: 640px;
        height: 80px;
        background: rgba(245, 245, 247, 1);
        margin: 24px auto;
        border-radius: 6px;
        margin-bottom: 60px;
        .el-input__inner {
          width: 100%;
          height: 100%;
          background: rgba(245, 245, 247, 1);
          border: none;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          // color: #A6ADC4;
          color: #333;
          line-height: 19px;
        }
      }
      ::v-deep .el-button--primary {
        display: block;
        width: 640px;
        height: 80px;
        margin: 0 auto;
        background: #338f6c;
        border-color: #338f6c;
        border-radius: 6px;
        font-size: 32px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 21px;
      }
    }
  }
}
</style>
